import { app, Component, ojs, payload } from "modular-openscriptjs";
import {
    isMobile,
    pageInfo,
    scrollToTop,
    searchPlaceholder,
} from "../../../helpers";
import MinimalProductView from "../../Views/MinimalProductView";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import Loader from "../../Blocks/Loader";
import { dom } from "../../../fotastart";
import SearchResultProductView from "../../Views/SearchResultProductView";
import { api, dc } from "../../../declarations";
import Spinner from "../../Blocks/Spinner";
import QuickOrderCard from "./QuickOrderCard";
import { $e } from "../../../ojs.events";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(
    MinimalProductView,
    InfiniteScroll,
    Spinner,
    SearchResultProductView,
    QuickOrderCard,
);

export default class SubcategoryProductsDefault extends Component {
    page = 1;
    lastPage = false;
    holder = null;

    initPage() {
        this.page = 1;
        this.lastPage = false;
    }

    render(...args) {
        pageInfo(dc.currentCategory?.name || "Subcategory Products");
        scrollToTop();

        searchPlaceholder(
            "Search in " + (dc.currentCategory?.name || "Subcategory"),
        );

        return h.div(
            {
                class: "py-4 mx-auto w-100 container py-md-5",
            },

            h.h2({ class: "fw-bold mb-4 px-1" }, dc.currentCategory?.name),

            h.InfiniteScroll({
                child: h.div({
                    class: "d-flex gap-3 gap-md-4 flex-wrap justify-content-around justify-content-md-start",
                    hook: "subcategory-products-list",
                }),
                callback: (entries, observer, marker) => {
                    if (entries[0]?.isIntersecting && !this.lastPage) {
                        this.getProducts(marker);
                    }
                },
            }),

            ...args,
        );
    }

    async getProducts(marker) {
        if (this.lastPage) {
            return;
        }

        const holder = dom.get("[hook='subcategory-products-list']");

        const spinner = h.Spinner({
            class: "p-3",
            parent: marker,
            resetParent: true,
        });

        const categoryId = router.params.categoryId;

        let res = await api.get(
            `/categories/${categoryId}/products`,
            {
                page: this.page,
                interval: 10,
            },
            { silent: true },
        );

        if (!res) {
            spinner.remove();
            return;
        }

        const products = res.data.products.data;

        for (let product of products) {
            let id = `p-${product?.id}`;
            let rendered = false;

            if (dom.get(`[feed-product-id="${id}"]`, holder)) {
                rendered = true;
            }

            if (!rendered) {
                h.SearchResultProductView(product, {
                    class: "flex-shrink-0 h-100",
                    style: isMobile() ? "width: 150px;" : "width: 280px;",
                    parent: holder,
                    $catalog_product_id: id,
                    listeners: {
                        click: () => {
                            broker.send(
                                $e.product.needs.display,
                                payload({ product }),
                            );
                        },
                    },
                });
            }
        }

        if (this.page == res.data.products.last_page) {
            h.div(h.QuickOrderCard(), { parent: holder, class: "w-100 mt-4" });
            this.lastPage = true;
        } else {
            h.button(
                h.i({
                    class: "bi bi-arrow-down-circle me-2 fs-5",
                    style: "line-height: 0;",
                }),
                "Load More",
                {
                    parent: marker,
                    class: "btn btn-outline-primary d-flex align-items-center justify-content-center mx-auto my-4 rounded-pill px-4 fw-semibold",
                    listeners: {
                        click: () => this.getProducts(marker),
                    },
                },
            );
        }

        this.page = res.data.products.current_page + 1;

        spinner.remove();
    }
}

ojs(SubcategoryProductsDefault);
